export default __webpack_public_path__ + "static/media/overwhelm2.a6ea0bc2.png";